import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from 'ui-toolkit/rest/BaseUrlService';

export const patchDeactivateClientUserAsync = ({
  clientCompanyId,
  clientUserId,
}: {
  clientCompanyId: string;
  clientUserId: string;
}) =>
  APIFactory(baseUrlService.ApiLocation)
    .patch(`/timber/api/internal/client_companies/${clientCompanyId}/client_users/${clientUserId}/deactivate`)
    .then((t) => t.data)
    .catch(axiosErrorHandler);
